// Site footer: column headings, links, company address, and copyright.
export default {
  en: {
    home: 'GAMZOR home',
    explore: 'Explore',
    legal: 'Legal',
    linkHome: 'Home',
    linkCatalog: 'Catalog',
    linkArticles: 'Articles',
    linkHelp: 'Help & FAQ',
    linkPrivacy: 'Privacy',
    linkTerms: 'Terms',
    linkCookies: 'Cookies',
    linkContact: 'Contact',
    mobile: 'Mobile',
    rights: '© {year} gamzor.net. All rights reserved.',
    account: 'Account',
    blurb: 'Game keys for Steam, PlayStation, Xbox, Nintendo, Epic and GOG — paid in EUR, delivered the moment your payment clears.',
    paymentMethods: 'Accepted payment methods',
    regNumber: 'reg. no. {number}',
    shop: 'Shop',
    platforms: 'Platforms',
  },
  cs: {
    home: 'GAMZOR domů',
    explore: 'Objevovat',
    legal: 'Právní informace',
    linkHome: 'Domů',
    linkCatalog: 'Katalog',
    linkArticles: 'Články',
    linkHelp: 'Nápověda a časté dotazy',
    linkPrivacy: 'Soukromí',
    linkTerms: 'Podmínky',
    linkCookies: 'Cookies',
    linkContact: 'Kontakt',
    mobile: 'Mobil',
    rights: '© {year} gamzor.net. Všechna práva vyhrazena.',
    account: 'Účet',
    blurb: 'Herní klíče pro Steam, PlayStation, Xbox, Nintendo, Epic a GOG — platba v EUR, doručení ihned po potvrzení platby.',
    paymentMethods: 'Přijímané platební metody',
    regNumber: 'IČO {number}',
    shop: 'Obchod',
    platforms: 'Platformy',
  },
};
